import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPause = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: "1em",
	height: "1em",
	viewBox: "0 0 24 24",
	fill: "var(--icon-color, currentColor)",
	className: "lucide lucide-pause-icon lucide-pause",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 14,
		y: 3,
		width: 5,
		height: 18,
		rx: 1
	}), /* @__PURE__ */ _jsx("rect", {
		x: 5,
		y: 3,
		width: 5,
		height: 18,
		rx: 1
	})]
});
export default SvgPause;
